import React, {Fragment} from "react";
import ToastHelper from "../../utils/ToastHelper";
import AgentAnnouncementService from "../../services/agentannouncement/AgentAnnouncementService";
import AgentAnnouncementCategoryService from "../../services/agentannouncement/AgentAnnouncementCategoryService";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import S3DocumentUploadService from "../../services/S3DocumentUploadService";
import "./agentannouncement.css";
import * as DateFormatter from "../../utils/DateFormatter";

export default class AgentAnnouncementIndex extends React.Component {

    constructor(props) {
        super(props);

        this.props.changeHeader("Announcements");

        this.state = {
            isLoading: true,
            announcements: [],
            categories: [],
            isMenuOpen: false,
            openCategory: 0
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let promiseArray = [];

        let ANNOUNCEMENT_INDEX = -1;
        let CATEGORY_INDEX = -1;

        ANNOUNCEMENT_INDEX = promiseArray.length;
        promiseArray.push(AgentAnnouncementService.retrieveAllActive());

        CATEGORY_INDEX = promiseArray.length;
        promiseArray.push(AgentAnnouncementCategoryService.retrieveAll());

        let newState = {};

        Promise.all(promiseArray).then(response => {

            if (response[ANNOUNCEMENT_INDEX]["errors"]) {
                ToastHelper.formatError(response[ANNOUNCEMENT_INDEX])
            } else {
                newState.announcements = response[ANNOUNCEMENT_INDEX];
            }

            if (response[CATEGORY_INDEX]["errors"]) {
                ToastHelper.formatError(response[CATEGORY_INDEX])
            } else {
                newState.categories = response[CATEGORY_INDEX];
            }

            newState.isLoading = false;

            newState.announcementCount = this.getAnnouncementCount(response[ANNOUNCEMENT_INDEX], response[CATEGORY_INDEX]);

            this.setState(newState)
        });
    }

    getAnnouncementCount(announcements, categories) {
        let announcementCountMap = {};

        if (announcements !== undefined && categories !== undefined) {
            categories.forEach((category) => {
                let count = 0;
                announcements.forEach((announcement) => {
                    if (category.id === announcement.categoryId) {
                        count++;
                    }
                });
                announcementCountMap[category.id] = count;
            });
        }
        return announcementCountMap;
    }

    toggleMenu(categoryId) {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen,
            openCategory: categoryId
        })
    }

    render() {
        if (this.state.isLoading) {
            return <SFXLoadingComponent/>
        }
        return <Fragment>
            {
                this.state.announcements.length > 0
                    ? this.renderAnnouncements()
                    : 'No Announcements'
            }
        </Fragment>
    }

    renderAnnouncements() {
        return <div className={"announcementsTileContainer"}><Fragment>
            {this.state.categories.map((category, index) => {
                return <Fragment key={index}>
                    <div className={"announcementsTile"} onClick={() => this.toggleMenu(category.id)}>
                    <div className={"announcementsTileHeading"}>
                            {category.name}
                        </div>
                        <div className={"announcementsCount"}>
                            {" ( " + this.state.announcementCount[category.id] + " )"}
                        </div>
                        {this.state.isMenuOpen && this.state.openCategory === category.id ?
                            <div className={"announcementsCountOnclick"}><i
                                className={"fa fa-angle-up"}/></div>
                            :
                            <div className={"announcementsCountOnclick"}><i
                                className={"fa fa-angle-down"}/></div>
                        }
                    </div>
                    {this.state.isMenuOpen && this.state.openCategory === category.id && <Fragment>
                        {this.state.announcements.map((announcement, index) => {
                            return <Fragment key={index}> {
                                announcement.categoryId === category.id &&
                                <Fragment key={index}>
                                    {this.renderAnnouncement(announcement)}
                                </Fragment>
                            }
                            </Fragment>
                        })
                        }
                        <br />
                    </Fragment>
                    }
                </Fragment>
            })}
        </Fragment>
        </div>
    }

    renderAnnouncement(announcement) {
        return <Fragment>
            <div className={"announcementsTileContentSection"}>
                <b className={"announcementsTileContentSectionHeading"} >{announcement.title}</b>
                <div className={"announcementsTileContentSectionDate"}>{DateFormatter.prettifyDate(announcement.dateCreated)}</div>
                <br/>
                <div>{announcement.description}</div>
                <hr/>
                {announcement.links.length === 0 ? <Fragment><b>No Documents Attached</b></Fragment> :
                    <div style={{display: "flex"}}>
                        {announcement.links.map((link, index) => {
                            return <Fragment key={index}>
                                {this.renderDocumentWithoutCloseButton(link)}
                            </Fragment>
                        })}
                    </div>
                }
            </div>
        </Fragment>
    }

    renderDocumentWithoutCloseButton(file) {
        if (file === undefined)
            return <Fragment>No file specified</Fragment>;

        return <div style={{
            marginRight: "20px"
        }}>
            {(!file.link.includes("youtube")) ? <Fragment>
                    <div onClick={() => this.getPdf(file.link)}>
                        <i className={"fa fa-file-pdf-o announcement-document"} style={{
                            fontSize: "40pt",
                            color: "red"
                        }}/>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <div onClick={() => this.openYoutubeWindow(file.link)}>
                        <i className={"fa fa-file-video-o announcement-document"} style={{
                            fontSize: "40pt",
                            color: "#446492"
                        }}/>
                    </div>
                </Fragment>
            }
        </div>
    }

    openYoutubeWindow(link) {
        let newWindow = window.open(link);
        newWindow.focus();
        return true;
    }

    getPdf(link) {
        S3DocumentUploadService.retrieveS3DocumentWithUrl(link).then(response => {
            if (!response["errors"]) {
                let newWindow = window.open(response.presignedUrl, response.id, 'left=20,top=20,toolbar=1,resizable=0');
                newWindow.focus();
            }
        });
    }
}
